"use client";

import React, { useState } from "react";

import Heading from "@/components/heading/heading";

const Destination = () => {
    const PopularList = [
        {
            name: "Thailand",
            url: "/thailand",
        },
        {
            name: "Maldives",
            url: "/maldives",
        },
        {
            name: "Bali",
            url: "/bali",
        },

        {
            name: "Singapore",
            url: "/singapore",
        },
        {
            name: "Malaysia",
            url: "/malaysia",
        },
        {
            name: "Dubai",
            url: "/dubai",
        },
        {

            name: "Sri Lanka",
            url: "/srilanka",
        },
        {
            name: "Vietnam",
            url: "/vietnam",
        },
        {
            name: "Hong Kong",
            url: "/hongkong",
        },
        {
            name: "Andaman",
            url: "/andaman",
        },
        {
            name: "Azerbaijan",
            url: "/azerbaijan",
        },
        {
            name: "Cambodia",
            url: "/cambodia-tour-packages",
        },

        {
            name: "Turkey",
            url: "/turkey",
        },
        {
            name: "Japan",
            url: "/japan",
        },
    ];
    const PackagesListfirst = [
        {
            name: "Thailand Honeymoon Packages",
            url: "/thailand/honeymoon-packages",
        },
        {
            name: "Maldives Honeymoon Packages",
            url: "/maldives/honeymoon-packages",
        },
        {
            name: "Bali Honeymoon Packages",
            url: "/bali/honeymoon-packages",
        },
        {
            name: "Singapore Honeymoon Packages",
            url: "/singapore/honeymoon-packages",
        },
        {
            name: "Malaysia Honeymoon Packages",
            url: "/malaysia/honeymoon-packages",
        },


    ];
    const PackagesListsecond = [

        {
            name: "Dubai Honeymoon Packages",
            url: "/dubai/honeymoon-packages",
        },
        {
            name: "Sri Lanka Honeymoon Packages",
            url: "/srilanka/honeymoon-packages",
        },
        {
            name: "Vietnam Honeymoon Packages",
            url: "/vietnam/honeymoon-packages",
        },
        {
            name: "Hong Kong Honeymoon Packages",
            url: "/hongkong/honeymoon-packages",
        },
        {
            name: "Andaman Honeymoon Packages",
            url: "/andaman/honeymoon-packages",
        },


    ];
    const PackageListfive = [

        {
            name: "Japan Honeymoon Packages",
            url: "/japan/honeymoon-packages",
        },

    ];
    const PackageListthird = [
        {
            name: "Thailand Family Packages",
            url: "/thailand/family-packages",
        },
        {
            name: "Maldives Family Packages",
            url: "/maldives/family-packages",
        },
        {
            name: "Bali Family Packages",
            url: "/bali/family-packages",
        },
        {
            name: "Singapore Family Packages",
            url: "/singapore/family-packages",
        },
        {
            name: "Malaysia Family Packages",
            url: "/malaysia/family-packages",
        },
        {
            name: "Dubai Family Packages",
            url: "/dubai/family-packages",
        },


    ];
    const PackageListfour = [

        {
            name: "Sri Lanka Family Packages",
            url: "/srilanka/family-packages",
        },
        {
            name: "Vietnam Family Packages",
            url: "/vietnam/family-packages",
        },
        {
            name: "Hongkong Family Packages",
            url: "/hongkong/family-packages",
        },
        {
            name: "Andaman Family Packages",
            url: "/andaman/family-packages",
        },
        {
            name: "Japan Family Packages",
            url: "/japan/family-packages",
        },


    ];

    const Combolist = [
        {
            name: "Singapore Malaysia Thailand Tour Package",
            url: "/singapore-malaysia-thailand-tour-package",
        },
        {
            name: "Singapore Malaysia Bali Tour Package",
            url: "/singapore-malaysia-bali-tour-package",
        },
        {
            name: "Bangkok Pattaya Tour Package",
            url: "/bangkok-pattaya-tour-packages",
        },
        {
            name: "Bangkok Pattaya Phuket Tour Package",
            url: "/bangkok-pattaya-phuket-tour-packages",
        },
    ]
    const Combolist2 = [
        {
            name: "Phuket Krabi Tour Package",
            url: "/phuket-krabi-tour-packages",
        },
        {
            name: "Bangkok Pattaya Phuket Krabi Tour Package",
            url: "/bangkok-pattaya-phuket-krabi-tour-packages",
        },
    ]
type Tour = { name: string; url: string };
    const toursByCity: Record<string, Tour[]> = {
        Chennai: [
            { name: "Thailand Tours from Chennai", url: "/thailand-tour-packages-from-chennai" },
            { name: "Singapore Tours from Chennai", url: "/singapore-tour-packages-from-chennai" },
            { name: "Bali Tours from Chennai", url: "/bali-tour-packages-from-chennai" },
            { name: "Malaysia Tours from Chennai", url: "/malaysia-tour-packages-from-chennai" },
            { name: "Vietnam Tours from Chennai", url: "/vietnam-tour-packages-from-chennai" },
            { name: "Turkey Tours From Chennai", url: "/turkey-tour-packages-from-chennai" },
            { name: "Japan Tours From Chennai", url: "/japan-tour-packages-from-chennai" },
        ],
        Mumbai: [
            { name: "Thailand Tours from Mumbai", url: "/thailand-tour-packages-from-mumbai" },
            { name: "Singapore Tours from Mumbai", url: "/singapore-tour-packages-from-mumbai" },
            { name: "Bali Tours from Mumbai", url: "/bali-tour-packages-from-mumbai" },
            { name: "Malaysia Tours from Mumbai", url: "/malaysia-tour-packages-from-mumbai" },
            { name: "Vietnam Tours from Mumbai", url: "/vietnam-tour-packages-from-mumbai" },
            { name: "Azerbaijan Tours from Mumbai", url: "/azerbaijan-tour-packages-from-mumbai" },
            { name: "Turkey Tours From Mumbai", url: "/turkey-tour-packages-from-mumbai" },
            { name: "Japan Tours From Mumbai", url: "/japan-tour-packages-from-mumbai" },
        ],
        Kolkata: [
            { name: "Thailand Tours from Kolkata", url: "/thailand-tour-packages-from-kolkata" },
            { name: "Bali Tours from Kolkata", url: "/bali-tour-packages-from-kolkata" },
            { name: "Malaysia Tours from Kolkata", url: "/malaysia-tour-packages-from-kolkata" },
            { name: "Vietnam Tours from Kolkata", url: "/vietnam-tour-packages-from-kolkata" },
            { name: "Turkey Tours From Kolkata", url: "/turkey-tour-packages-from-kolkata" },
            { name: "Japan Tours From Kolkata", url: "/japan-tour-packages-from-kolkata" },
        ],
        Kerala: [
            { name: "Thailand Tours from Kerala", url: "/thailand-tour-packages-from-kerala" },
            { name: "Malaysia Tours from Kerala", url: "/malaysia-tour-packages-from-kerala" },
            { name: "Vietnam Tours from Kerala", url: "/vietnam-tour-packages-from-kerala" },
            { name: "Azerbaijan Tours from Kerala", url: "/azerbaijan-tour-packages-from-kerala" },
            { name: "Turkey Tours From Kerala", url: "/turkey-tour-packages-from-kerala" },
            { name: "Japan Tours From Kerala", url: "/japan-tour-packages-from-kerala" },
        ],
        Delhi: [
            { name: "Thailand Tours from Delhi", url: "/thailand-tour-packages-from-delhi" },
            { name: "Bali Tours from Delhi", url: "/bali-tour-packages-from-delhi" },
            { name: "Vietnam Tours from Delhi", url: "/vietnam-tour-packages-from-delhi" },
            { name: "Turkey Tours From Delhi", url: "/turkey-tour-packages-from-delhi" },
            { name: "Japan Tours From Delhi", url: "/japan-tour-packages-from-delhi" },
        ],
        Bangalore: [
            { name: "Thailand Tours from Bangalore", url: "/thailand-tour-packages-from-bangalore" },
            { name: "Vietnam Tours from Bangalore", url: "/vietnam-tour-packages-from-bangalore" },
            { name: "Malaysia Tours from Bangalore", url: "/malaysia-tour-packages-from-bangalore" },
            { name: "Turkey Tours From Bangalore", url: "/turkey-tour-packages-from-bangalore" },
            { name: "Japan Tours From Bangalore", url: "/japan-tour-packages-from-bangalore" },
        ],
        
        Pune: [
            { name: "Thailand Tours from Pune", url: "/thailand-tour-packages-from-pune" },
            { name: "Vietnam Tours from Pune", url: "/vietnam-tour-packages-from-pune" },
        ],
        Ahmedabad: [
            { name: "Singapore Tours from Ahmedabad", url: "/singapore-tour-packages-from-ahmedabad" },
            { name: "Vietnam Tours from Ahmedabad", url: "/vietnam-tour-packages-from-ahmedabad" },
        ],
        
        Hyderabad: [
            { name: "Thailand Tours from Hyderabad", url: "/thailand-tour-packages-from-hyderabad" },
            { name: "Vietnam Tours from Hyderabad", url: "/vietnam-tour-packages-from-hyderabad" },
        ],
        
        Kochi: [
            { name: "Thailand Tours from Kochi", url: "/thailand-tour-packages-from-kochi" },
            { name: "Vietnam Tours from Kochi", url: "/vietnam-tour-packages-from-kochi" },
        ],
        Coimbatore: [
            { name: "Thailand Tours from Coimbatore", url: "/thailand-tour-packages-from-coimbatore" },
        ],
    };


                const [openCity, setOpenCity] = React.useState<string | null>(null);

    return (
        <div className="destination-block flex flex-col gap-4">
            <div className="popular-block destination-inner flex flex-col gap-2 pb-4">
                <Heading as="h6" className="font-semibold">
                    Popular Destination
                </Heading>
                <ul className="destination-list popular-list flex flex-wrap gap-3 items-center">
                    {PopularList.map((pl, index) => {
                        return (
                            <li
                                className="popular-list-item list flex items-center gap-3"
                                key={index}
                            >
                                <a href={pl.url}>{pl.name}</a>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className="package-block destination-inner flex flex-col gap-2 pb-4">
                <Heading as="h6" className="font-semibold">
                    Honeymoon Packages
                </Heading>
                <ul className="destination-list package-laist list flex flex-wrap gap-3 items-center">
                    {PackagesListfirst.map((p, index) => {
                        return (
                            <li
                                className="package-list-item flex items-center gap-3"
                                key={index}
                            >
                                <a href={p.url}>{p.name}</a>
                            </li>
                        );
                    })}
                </ul>
                <ul className="destination-list package-laist list flex flex-wrap gap-3 items-center">
                    {PackagesListsecond.map((p, index) => {
                        return (
                            <li
                                className="package-list-item flex items-center gap-3"
                                key={index}
                            >
                                <a href={p.url}>{p.name}</a>
                            </li>
                        );
                    })}
                </ul>
                <ul className="destination-list package-laist list flex flex-wrap gap-3 items-center">
                    {PackageListfive.map((p, index) => {
                        return (
                            <li
                                className="package-list-item flex items-center gap-3"
                                key={index}
                            >
                                <a href={p.url}>{p.name}</a>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className="package-block destination-inner flex flex-col gap-2 pb-4">
                <Heading as="h6" className="font-semibold">
                    Family Tour Packages
                </Heading>
                <ul className="destination-list package-laist list flex flex-wrap gap-3 items-center">
                    {PackageListthird.map((p, index) => {
                        return (
                            <li
                                className="package-list-item flex items-center gap-3"
                                key={index}
                            >
                                <a href={p.url}>{p.name}</a>
                            </li>
                        );
                    })}
                </ul>
                <ul className="destination-list package-laist list flex flex-wrap gap-3 items-center">
                    {PackageListfour.map((p, index) => {
                        return (
                            <li
                                className="package-list-item flex items-center gap-3"
                                key={index}
                            >
                                <a href={p.url}>{p.name}</a>
                            </li>
                        );
                    })}
                </ul>
            </div>

            <div className="popular-block destination-inner flex flex-col gap-2 pb-4">
                <Heading as="h6" className="font-semibold">
                    Combo Packages
                </Heading>
                <ul className="destination-list popular-list flex flex-wrap gap-3 items-center">
                    {Combolist.map((pl, index) => {
                        return (
                            <li
                                className="popular-list-item list flex items-center gap-3"
                                key={index}
                            >
                                <a href={pl.url}>{pl.name}</a>
                            </li>
                        );
                    })}
                </ul>
                <ul className="destination-list popular-list flex flex-wrap gap-3 items-center">
                    {Combolist2.map((pl, index) => {
                        return (
                            <li
                                className="popular-list-item list flex items-center gap-3"
                                key={index}
                            >
                                <a href={pl.url}>{pl.name}</a>
                            </li>
                        );
                    })}
                </ul>
            </div>

            <div className="package-block destination-inner flex flex-col gap-2 pb-4">
                <Heading as="h6" className="font-semibold">
                    Packages by Cities
                </Heading>
                    <div className="from-city flex flex-col md:flex-row flex-wrap gap-4">

{Object.keys(toursByCity).map((city, idx) => {
    const isOpen = openCity === city;

    return (
        <div className="accordion mt-3" key={idx}>
            <div
                className="accordion-header font-semibold w-full cursor-pointer text-left flex items-center"
                onClick={() => setOpenCity(isOpen ? null : city)} // toggle
            >
                <Heading as="h6" className="semibold">
                    International Tours From {city}
                </Heading>
                <span>{isOpen ? "−" : "+"}</span>
            </div>

            {isOpen && (
                <ul className="accordion-content destination-list package-laist list flex md:flex-col flex-wrap gap-3">
                    {toursByCity[city].map((p, index) => (
                        <li
                            className="package-list-item flex items-center gap-3"
                            key={index}
                        >
                            <a href={p.url}>{p.name}</a>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
})}

                </div>
            </div>

        </div>
    );
};

export default Destination;
